/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrReplaceGoalRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {CreateOrReplaceGoalResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const createOrReplaceGoal = (request: CreateOrReplaceGoalRequest, options?: CashRequestOptions) => post<CreateOrReplaceGoalRequest, CreateOrReplaceGoalResponse>("/2.0/cash/create-or-replace-goal", request, {...options, rejectOnError: true })